class FacetFiltersForm extends HTMLElement {
	constructor() {
		super();
		this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

		this.debouncedOnSubmit = debounce((event) => {
			this.onSubmitHandler(event);
		}, 500);

		const facetForm = this.querySelector('form');
		facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));
	}

	static setListeners() {
		const onHistoryChange = (event) => {
			const searchParams = event.state
				? event.state.searchParams
				: FacetFiltersForm.searchParamsInitial;
			if (searchParams === FacetFiltersForm.searchParamsPrev) return;
			FacetFiltersForm.renderPage(searchParams, null, false);
		};
		window.addEventListener('popstate', onHistoryChange);
	}

	static toggleActiveFacets(disable = true) {
		document.querySelectorAll('[data-facets-remove]').forEach((element) => {
			element.classList.toggle('disabled', disable);
		});
	}

	static renderPage(searchParams, event, updateURLHash = true) {
		FacetFiltersForm.searchParamsPrev = searchParams;
		const sections = FacetFiltersForm.getSections();

		sections.forEach((section) => {
			const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
			const filterDataUrl = (element) => element.url === url;

			FacetFiltersForm.filterData.some(filterDataUrl)
				? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
				: FacetFiltersForm.renderSectionFromFetch(url, event);
		});

		if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
	}

	static renderSectionFromFetch(url, event) {
		fetch(url)
			.then((response) => response.text())
			.then((responseText) => {
				const html = responseText;
				FacetFiltersForm.filterData = [
					...FacetFiltersForm.filterData,
					{html, url},
				];
				FacetFiltersForm.renderFilters(html, event);
				FacetFiltersForm.renderProductGridContainer(html);
				FacetFiltersForm.renderProductCount(html);
			});
	}

	static renderSectionFromCache(filterDataUrl, event) {
		const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
		FacetFiltersForm.renderFilters(html, event);
		FacetFiltersForm.renderProductGridContainer(html);
		FacetFiltersForm.renderProductCount(html);
	}

	static renderProductGridContainer(html) {
		let container = document.querySelector('[data-facets-products-grid]')
		container.innerHTML =
			new DOMParser()
				.parseFromString(html, 'text/html')
				.querySelector('[data-facets-products-grid]').innerHTML;

		document.dispatchEvent(new CustomEvent('update-grid-collection', { detail : { container: container } }));
	}

	static renderProductCount(html) {
		const count = new DOMParser()
			.parseFromString(html, 'text/html')
			.querySelector('[data-facets-count]').innerHTML;
		const containers = document.querySelectorAll('[data-facets-count]');
		containers.forEach(container => {
			container.innerHTML = count;
		});
	}

	static renderFilters(html, event) {
		const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

		const facetDetailsElements = parsedHTML.querySelectorAll(
			'[data-facets-form] [data-facets-filter]',
		);
		const matchesIndex = (element) => {
			const jsFilter = event
				? event.target.closest('[data-facets-filter]')
				: undefined;
			return jsFilter
				? element.dataset.index === jsFilter.dataset.index
				: false;
		};
		const facetsToRender = Array.from(facetDetailsElements).filter(
			(element) => !matchesIndex(element),
		);
		facetsToRender.forEach((element) => {
			document.querySelector(
				`[data-index="${element.dataset.index}"]`,
			).innerHTML = element.innerHTML;
		});

		FacetFiltersForm.renderActiveFacets(parsedHTML);
	}

	static renderActiveFacets(html) {
		const activeFacetElementSelectors = ['[data-facets-actives]'];

		activeFacetElementSelectors.forEach((selector) => {
			const activeFacetsElement = html.querySelector(selector);
			if (!activeFacetsElement) return;
			document.querySelector(selector).innerHTML =
				activeFacetsElement.innerHTML;
		});

		FacetFiltersForm.toggleActiveFacets(false);
	}

	static updateURLHash(searchParams) {
		history.pushState(
			{searchParams},
			'',
			`${window.location.pathname}${searchParams && '?'.concat(searchParams)}`,
		);
	}

	static getSections() {
		return [
			{
				section: document.querySelector('[data-facets-product-grid]').dataset
					.id,
			},
		];
	}

	static resetPriceInputs() {
		document.querySelectorAll('input[type="radio"][name="filter.v.price.lte"]').forEach((input) => {
			input.checked = false;
		});
	}

	createSearchParams(form) {
		const formData = new FormData(form);
		return new URLSearchParams(formData).toString();
	}

	onSubmitForm(searchParams, event) {
		FacetFiltersForm.renderPage(searchParams, event);
	}

	onSubmitHandler(event) {
		event.preventDefault();
		const sortFilterForms = document.querySelectorAll(
			'facet-filters-form form',
		);
		const forms = [];

		sortFilterForms.forEach((form) => {
			if (form.id === 'FacetFiltersForm') {
				forms.push(this.createSearchParams(form));
			}
		});
		this.onSubmitForm(forms.join('&'), event);
	}

	onActiveFilterClick(event) {
		event.preventDefault();
		FacetFiltersForm.toggleActiveFacets();
		const url =
			event.currentTarget.href.indexOf('?') == -1
				? ''
				: event.currentTarget.href.slice(
						event.currentTarget.href.indexOf('?') + 1,
					);
		FacetFiltersForm.renderPage(url);
	}
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
	constructor() {
		super();
		this.querySelectorAll('input').forEach((element) =>
			element.addEventListener('change', this.onRangeChange.bind(this)),
		);
		this.setMinAndMaxValues();
	}

	onRangeChange(event) {
		this.adjustToValidValues(event.currentTarget);
		this.setMinAndMaxValues();
	}

	setMinAndMaxValues() {
		const inputs = this.querySelectorAll('input');
		const minInput = inputs[0];
		const maxInput = inputs[1];
		if (maxInput.value) minInput.setAttribute('max', maxInput.value);
		if (minInput.value) maxInput.setAttribute('min', minInput.value);
		if (minInput.value === '') maxInput.setAttribute('min', 0);
		if (maxInput.value === '')
			minInput.setAttribute('max', maxInput.getAttribute('max'));
	}

	adjustToValidValues(input) {
		const value = Number(input.value);
		const min = Number(input.getAttribute('min'));
		const max = Number(input.getAttribute('max'));

		if (value < min) input.value = min;
		if (value > max) input.value = max;
	}
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
	constructor() {
		super();
		const facetLink = this.querySelector('a');
		facetLink.setAttribute('role', 'button');
		facetLink.addEventListener('click', this.closeFilter.bind(this));
		facetLink.addEventListener('keyup', (event) => {
			if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
		});
	}

	closeFilter(event) {
		event.preventDefault();
		const form = this.closest('facet-filters-form');
		form.onActiveFilterClick(event);
		FacetFiltersForm.resetPriceInputs();
	}
}

customElements.define('facet-remove', FacetRemove);
